/** Parses JSON error payloads and network errors from Edge Function calls. */
export function getEdgeFunctionErrorMessage(error: unknown, data: unknown): string {
  if (data && typeof data === "object") {
    const d = data as Record<string, unknown>;
    if (typeof d.message === "string" && d.message.trim() !== "") return d.message;
    if (typeof d.error === "string" && d.error.trim() !== "") return d.error;
  }
  if (error instanceof Error && error.message) return error.message;
  return "Edge function request failed";
}
